import { Component } from "react"

class Password extends Component{
    constructor(props){
        super(props)
        this.name = "ログインパスワード"
    }
    validate(callbackDialog,requireCheck){
        if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(String(this.props).trim().length > 0){
            if(this.props.length < 8 || this.props.length > 30){
                callbackDialog("エラー",this.name + "は8文字以上30文字以内にしてください。")
                return false
            }
            if(!/^[a-zA-Z0-9!@]+$/.test(this.props)){
                callbackDialog("エラー",this.name + "で使用できる文字列はa～z、A～Z、0～9、!、@です。")
                return false
            }
        }
        return true
    }
}

export default Password;